/**
 * Trigger a browser download of a Blob with the given filename.
 *
 * Used when the file content is already in memory as a Blob (e.g. an XLSX
 * streamed back from an API call with `responseType: 'blob'`). The standard
 * `<a download>` click pattern, wrapped so callers don't repeat the
 * createObjectURL / appendChild / click / remove / revokeObjectURL dance.
 */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/**
 * Parse the filename from a Content-Disposition header value, or return null.
 * Handles the common `attachment; filename="foo.xlsx"` shape.
 */
export function parseContentDispositionFilename(header: string | null | undefined): string | null {
  if (!header) return null;
  const match = /filename="([^"]+)"/.exec(header);
  return match?.[1] ?? null;
}
